import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';

// declarado p/ strict mode (era global implicito)
var content;

export const infoComplementar = function (filhos, filhosID) {
    "use strict";

    var $divPanel = '#panel-complementar';
    var $panel = body.find($divPanel);

    var _listar = function (filhos, filhosID) {
        window.global.loaderPanel.show($divPanel);

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetInfoComplementar', cache: false,
            success: function (dados) {
                var html = [], habilitacao = '', veiculoProprio = '', itensSelected = [];
                var elementNull = document.getElementById("complementar-null");


                if (dados.length > 0 || filhos != 'Não informado') {
                    elementNull.className = 'hide';

                    if (filhos != '') {
                        html.push('<div class="col-sm-6 container-filhos"><p><i class="fa fa-child"></i> ' + filhos + '</p></div>');
                    }
                    if (dados != '') {
                        for (var i = 0; i < dados.length; i++) {
                            itensSelected.push(dados[i].id);
                            if (dados[i].id === 1) {
                                html.push('<div class="col-sm-6 container-mudanca hide"><p>' + dados[i].texto + '</p></div>');
                            }
                            else if (dados[i].id === 2) {
                                html.push('<div class="col-sm-6 container-viajar hide"><p>' + dados[i].texto + '</p></div>');
                            }
                            else if (dados[i].id === 3 || dados[i].id === 4 || dados[i].id === 5 || dados[i].id === 6 || dados[i].id === 7) {

                                habilitacao += dados[i].texto + ', ';
                            }
                            else {
                                veiculoProprio += dados[i].texto + '&nbsp;&nbsp;&nbsp;';
                            }
                        }
                        if (habilitacao != '') {
                            html.push('<div class="col-sm-6 container-habilitacao"><p>' + i18next.t('complementarHab') + '<br>' + habilitacao + '</p></div>');
                        }
                        if (veiculoProprio != '') {
                            html.push('<div class="col-sm-6 container-veiculo hide"><p>' + i18next.t('complementarVeiculo') + '<br>' + veiculoProprio + '</p></div>');
                        }
                    }


                    if (html.join('') != '') {
                        html.push('<div class="elementos-editar" data-filhos="' + filhosID + '" data-itens="' + itensSelected + '"></div>');
                        document.getElementById('complementar-lista').innerHTML = html.join('');
                        $panel.find('.btn-add').removeClass('hide');
                    } else {
                        elementNull.className = '';
                        document.getElementById('complementar-lista').innerHTML = '';
                    }

                } else {
                    elementNull.className = '';
                    document.getElementById('complementar-lista').innerHTML = '';
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    var _salvar = function () {
        var $form = $panel.find('#form-complementar');
        window.global.loaderButton.show($form.find('button[type=submit]'));

        var data = $form.serialize();
        if ($('#residencia-sim').is(':checked')) {
            data += '&CurriculoAdicional=1';
        }
        var filhos = $form.find("#filhos option:selected").text();
        var filhosID = $form.find('#filhos').val();
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveInfoComplementar', cache: false,
            data: data,
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('complementarSalva'), '', { "closeButton": true });
                    _listar(filhos, filhosID);
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('complementar-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    var _abrir = function () {
        goToByScroll($divPanel);

        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = $panel.find('#complementar-contentform');
        abrirFormCadastro();
        formulario.load(_URL_FORM + "InfoComplementares?v=2", function () {
            $.validate({
                form: '#form-complementar'
            });
            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-complementar').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });
            var elementos = $panel.find('.elementos-editar');
            if (elementos.length > 0) {
                formulario.find('#filhos').val(elementos.attr('data-filhos'));
                var selected = JSON.parse("[" + elementos.attr('data-itens') + "]");
                for (var i = 0; i < selected.length; i++) {
                    if (selected[i] == '1') {
                        formulario.find('#residencia-sim').prop('checked', true);
                    } else {
                        formulario.find('#adicional-' + selected[i]).prop('checked', true);
                    }
                }
            }
            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide($divPanel);
        });


    };

    var init = function () {
        _listar(filhos, filhosID);

        body.find($divPanel).find('.btn-add').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });
    }

    return init();
};

